import { FC } from 'react';
import { ComparisonNavChart } from './components';
import { useGetFundDetailsData } from '../../../../hooks/useGetFundDetailsData';
import { EfficiencyCompareSkeleton } from './EfficiencyCompare.skeleton';

export const EfficiencyCompare: FC = () => {
  const { isLoading } = useGetFundDetailsData();

  if (isLoading) {
    return <EfficiencyCompareSkeleton />;
  }

  return <ComparisonNavChart />;
};
